exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MentionsLine .showMoreLess{white-space:normal;color:var(--link)}.MentionsLine .fullExtraMentions,.MentionsLine .mention-link:not(:last-child){margin-right:.25em}", ""]);

// exports
